import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";

const sectorFields = `
    id
    sectorUniqueId
    sectorIcon
    sectorCode
    sectorName
`;


export const CREATE_SECTOR = gql`
    mutation CreateInstitutionSectorMutation($input: InstitutionSectorInputObjects!) {
        createInstitutionSectorMutation(input: $input) {
            response {
                ${baseResponse}
            }
            data {
                ${sectorFields}
            }
        }
    }
`;

export const UPDATE_SECTOR = gql`
    mutation UpdateInstitutionSectorMutation($input: InstitutionSectorInputObjects!) {
        updateInstitutionSectorMutation(input: $input) {
            response {
                ${baseResponse}
            }
            data {
                ${sectorFields}
            }
        }
    }
`;

export const GET_ALL_SECTORS = gql`
    query GetAllSectors($filtering: InstitutionSectorFilteringInputObjects){
        getAllSectors(filtering:$filtering){
            response {
                ${baseResponse}
            }
            data {
                ${sectorFields}
            }
        }
    }
`;
